export const CORE_DOMAIN_SEARCH_TRANSLATIONS_NS = 'core-domain-search-translations-ns';
export const resourceLoader = async locale => {
  return import(`./locale/messages_${locale}.json`);
};
//# sourceMappingURL=resourceLoader.js.map